module.exports = __webpack_public_path__ + "dash_20_app_assets/img/ctorcircle.0279a775.png";